const state = {
  tiposEmail: [
    { id_tipo_email: 1, descricao: 'GERAL' },
    { id_tipo_email: 2, descricao: 'NFE' },
    { id_tipo_email: 3, descricao: 'FINANCEIRO' },
    { id_tipo_email: 4, descricao: 'COMERCIAL' },
    { id_tipo_email: 5, descricao: 'OUTROS' },
  ]
};

const getters = {
  tiposEmail: state => state.tiposEmail,
};

const actions = {};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
}